// tr strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "Kendi yapay zeka sesini eğit | Jammable",
  "train.seo.description":
    "Jammable'da kendi yapay zeka sesini eğit. Ses dosyalarını yükle, bir ses modeli eğit ve toplulukla paylaş ya da gizli tut.",
  "train.h1": "Ses eğit",
  "train.sub":
    "Birkaç dakikalık temiz şarkı ya da konuşma kaydı ver, cover'larında kullanabileceğin bir ses al.",
  "train.voicesTrained": "{count} ses eğitildi",

  "train.faq.title": "Sık sorulan sorular",
  "train.faq.dataset.q": "Veri seti nedir?",
  "train.faq.dataset.a1": "Vokal içeren ses dosyalarından oluşan bir set.",
  "train.faq.dataset.a2":
    "En az {min} dakika şarkı ya da konuşma, tercihen 10+ dakika.",
  "train.faq.dataset.a3": "MP3, WAV ya da M4A formatında.",
  "train.faq.private.q": "Kendi sesim gizli kalacak mı?",
  "train.faq.private.a":
    "Evet! Gizli tutmayı seçersen ses modeline yalnızca sen erişebilir, onu görebilir ve kullanabilirsin!",
  "train.faq.time.q": "Sesimin eğitimi ne kadar sürer?",
  "train.faq.time.a":
    "Eklediğin ses miktarına bağlı: 10 dakikalık ses için genellikle {short}, bir saatlik ses için {long}. Sayfayı kapatabilirsin; hazır olunca sana e-posta göndereceğiz.",

  "train.eta.minutes": "yaklaşık {m} dakika",
  "train.eta.hour": "yaklaşık {h} saat",
  "train.eta.hours": "yaklaşık {h} saat",
  "train.eta.hourMinutes": "yaklaşık {h} saat {m} dakika",
  "train.eta.hoursMinutes": "yaklaşık {h} saat {m} dakika",
  "train.minutes": "{n} dakika",

  "train.samples": "Örnekler",
  "train.filesOne": "1 dosya · {time}",
  "train.filesMany": "{n} dosya · {time}",
  "train.passesLeft": "Kalan eğitim hakkı",
  "train.unlimited": "Sınırsız",
  "train.nameIt": "Adını koy",
  "train.creatorShort": "Eğitim, Creator planına dahil.",

  "train.upload.invalidType": "Geçersiz dosya türü.",
  "train.upload.skippedOne":
    "Atlandı: {names} zaten eklenmiş. Aynı sesi iki kez eklemek sesine katkı sağlamaz, bu yüzden yalnızca bir kez sayılır.",
  "train.upload.skippedMany":
    "Atlananlar: {names} zaten eklenmiş. Aynı sesi iki kez eklemek sesine katkı sağlamaz, bu yüzden yalnızca bir kez sayılır.",
  "train.upload.nFiles": "{n} dosya",
  "train.upload.someInvalid": "Bir ya da daha fazla dosya geçersiz.",
  "train.upload.failed": "Yükleme başarısız",
  "train.upload.needsPlan": "Yüklemek için plan gerekli",
  "train.upload.tooManyLabel":
    "Şu anda çok fazla yükleme var, birazdan tekrar dene",
  "train.upload.tooManyToast":
    "Şu anda çok fazla yükleme var. Birkaç dakika sonra tekrar dene.",
  "train.upload.analysing":
    "Dosyalarındaki sessiz kısımlar hâlâ bulunuyor. Bir saniye.",
  "train.upload.blocked":
    "Bazı dosyalar engellendi. Devam etmek için onları kaldır.",
  "train.upload.errored":
    "Bazı dosyalarda hata var. Devam etmek için onları kaldır.",
  "train.upload.processing":
    "Bazı dosyalar hâlâ işleniyor. Lütfen bitmelerini bekle.",
  "train.upload.tooShort":
    "Sessizlik hariç en az {min} şarkı ya da konuşma gerekiyor. Şu an: {have}.",
  "train.upload.tooLong":
    "En fazla {max} ses olabilir. Şu an: {have}. Bir dosyayı kaldır ya da biraz kes.",
  "train.upload.title": "Sesini ekle",
  "train.upload.ofMin": "/ {min}",
  "train.upload.overLimit": "{n} dakikalık sınırın {over} üzerinde",
  "train.upload.ready": "Hazır ✓",
  "train.upload.addMore": "{left} daha ekle",
  "train.upload.short":
    "Sesler genellikle {n}+ dakikayla daha iyi olur. Şimdi eğitebilir ya da varsa {left} daha ekleyebilirsin.",
  "train.upload.uploadFiles": "Dosya yükle",
  "train.upload.record": "Kaydet",
  "train.upload.addIt": "Ekle",
  "train.upload.recordHint":
    "Şarkı söyle ya da konuş. İstediğin kadar kayıt yap.",
  "train.upload.blockedFrom": "Engellendi - kaynağı şu olan içerik: {label}",
  "train.upload.gettingReady": "Hazırlanıyor...",
  "train.upload.ofVoice": "{time} ses",
  "train.upload.removed": "{time} kaldırıldı",
  "train.upload.uploading": "yükleniyor...",
  "train.upload.done": "Tamam",
  "train.upload.trim": "Kırp",
  "train.upload.retry": "Tekrar dene",
  "train.upload.remove": "Kaldır: {name}",
  "train.upload.silenceNote":
    "Sessiz kısımlar senin için kaldırılır. Mor kısımlar, sesinin öğrendiği yerlerdir.",
  "train.upload.tip1.title": "Tek bir ses",
  "train.upload.tip1.sub": "Arka vokal ya da kalabalık yok",
  "train.upload.tip2.title": "Sessiz oda",
  "train.upload.tip2.sub": "Yankı yok, arka plan gürültüsü yok",
  "train.upload.tip3.title": "Ne kadar çok, o kadar iyi",
  "train.upload.tip3.sub": "Farklı notalar ve kelimeler",
  "train.upload.nextHint":
    "Sırada: bir isim, bir görsel ve kimlerin kullanabileceği.",
  "train.upload.cardTitle": "Örneklerin",
  "train.upload.footnote":
    "En az {min} şarkı ya da konuşma ({rec}+ daha iyi sonuç verir), en fazla {max}. Sessizlik ve tekrarlanan dosyalar sayılmaz; sessizlik senin için kesilir.",
  "train.upload.footnoteNoRec":
    "En az {min} şarkı ya da konuşma, en fazla {max}. Sessizlik ve tekrarlanan dosyalar sayılmaz; sessizlik senin için kesilir.",
  "train.upload.creatorNote":
    "Eğitim, Creator planına dahil. Önce vokallerini yükle, kararı sonunda ver; ödemeden önce fiyatı göreceksin.",
  "train.upload.continue": "Devam et",

  "train.sample.play": "Çal: {label}",
  "train.sample.pause": "Duraklat: {label}",
  "train.clip.keptOf": "/ {total} tutuldu",
  "train.clip.silenceCut": "{time} sessizlik kesildi",
  "train.clip.cutByYou": "{time} senin tarafından kesildi",
  "train.clip.cut": "kesildi",
  "train.clip.play": "Çal",
  "train.clip.stop": "Durdur",
  "train.clip.keepIt": "Tut",
  "train.clip.cutIt": "Kes",
  "train.clip.cancel": "İptal",
  "train.clip.hint":
    "İstemediğin kısmın üzerinden sürükle, sonra kes. Dinlemek için dokun.",
  "train.clip.undo": "Kesmelerimi geri al",

  "train.info.samplesAdded": "Örnekler eklendi",
  "train.info.edit": "Düzenle",
  "train.info.namePlaceholder": "Ses adı, ör. Benim sesim",
  "train.info.descPlaceholder":
    "Açıklama - sesin nasıl eğitildiğini toplulukla paylaş...",
  "train.info.whoCanUse": "Kimler kullanabilir",
  "train.info.private": "Gizli, sadece ben",
  "train.info.public": "Kütüphanede herkese açık",
  "train.info.cleanUp": "Örnekleri temizle",
  "train.info.removeInstrumentals": "Enstrümanları kaldır",
  "train.info.removeInstrumentalsSub":
    "Veri setindeki vokal olmayan her şeyi temizler.",
  "train.info.removeReverb": "Yankıyı kaldır",
  "train.info.removeReverbSub":
    "Veri setindeki tüm seslerden yankıyı (reverb) temizler.",
  "train.info.cardTitle": "Eğitime hazır",
  "train.info.usuallyReadyIn": "Genellikle hazır olma süresi",
  "train.info.upTo2h": "En fazla 2 saat",
  "train.info.closePage":
    "Eğitim bizim tarafımızda çalışır, sayfayı kapatabilirsin.",
  "train.info.starting": "Başlatılıyor...",
  "train.info.start": "Eğitimi başlat",
  "train.info.orGetPass": "Ya da bir eğitim hakkı al",
  "train.info.getMorePasses": "Daha fazla eğitim hakkı al",
  "train.info.usesOnePass": "1 eğitim hakkı kullanır",
  "train.info.started": "Eğitim başladı",
  "train.info.onCreator": "Creator planındasın. Eğitimin başlatılıyor...",
  "train.info.legal":
    "Devam ederek Jammable'a yüklediğin içeriği kullanma hakkı veriyor ve BU İÇERİĞİN SANA AİT OLDUĞUNU VE ÜÇÜNCÜ TARAFLARA AİT TELİF HAKKIYLA KORUNAN MATERYAL İÇERMEDİĞİNİ ONAYLIYORSUN.",
  "train.info.agreeTerms": "Lütfen Kullanım Koşullarımızı kabul et!",
  "train.info.chooseName": "Lütfen bir ses adı seç!",
  "train.info.uploadImage": "Lütfen bir görsel yükle!",
  "train.info.invalidName": "Geçersiz model adı. Özel karakter kullanma",
  "train.info.signIn": "Giriş yapman gerekiyor",
  "train.info.errorStarting": "Eğitim başlatılırken hata oluştu",
  "train.info.errorSignedUrl": "İmzalı URL alınırken hata oluştu",

  "train.demo.title": "Eğitilmiş bir sesi dinle",
  "train.demo.by": "Bir Jammable Power kullanıcısından",
  "train.demo.data.label": "Eğitim verisi",
  "train.demo.data.note": "Birkaç dakikalık ses kaydı",
  "train.demo.input.label": "Giriş şarkısı",
  "train.demo.input.note": "Sesin söyleyeceği şarkı",
  "train.demo.output.label": "Sonuç",
  "train.demo.output.note": "Eğitilmiş sesle söylendi",
  "train.demo.play": "Çal: {label}",
  "train.demo.pause": "Duraklat: {label}",

  "train.retry.trainAgain": "Yeniden eğit",
  "train.retry.tryAgain": "Tekrar dene",
  "train.retry.orNewSamples": "Ya da yeni örneklerle eğit",
  "train.retry.retrying":
    "Yeniden eğitiliyor. Hazır olunca sana e-posta göndereceğiz.",
  "train.retry.couldntStart": "Eğitim başlatılamadı. Tekrar dene.",
  "train.retry.confirmUnlimited":
    "Aynı örneklerle yeniden eğiteceğiz. Planına dahil.",
  "train.retry.confirmOutCreator":
    "Tekrar denemek bir eğitim hakkı kullanır ve hiç hakkın kalmadı. Eğitim, Creator planına dahil.",
  "train.retry.confirmOut":
    "Tekrar denemek bir eğitim hakkı kullanır ve hiç hakkın kalmadı.",
  "train.retry.confirmPass":
    "Aynı örneklerle yeniden eğiteceğiz. 1 eğitim hakkı kullanır (kalan hakkın: {passes}); yine başarısız olursa hakkın iade edilir.",
  "train.retry.cancel": "İptal",
  "train.retry.seeCreator": "Creator'ı incele",
  "train.retry.getPass": "Eğitim hakkı al",
  "train.retry.orGetPass": "Ya da bir eğitim hakkı al",
  "train.retry.starting": "Başlatılıyor...",
  "train.retry.usePass": "Bir hak kullan ve tekrar dene",
  "train.retry.refuse.cleanVocals":
    "Tekrar denemek aynı şekilde başarısız olur. Temiz vokallerle yeniden eğit: müzik yok, uzun sessizlik yok.",
  "train.retry.refuse.formats":
    "Tekrar denemek aynı şekilde başarısız olur. Net şarkı ya da konuşma içeren MP3, WAV veya M4A dosyalarıyla yeniden eğit.",
  "train.retry.refuse.newSamples":
    "Tekrar denemek aynı şekilde başarısız olur. Yeni örneklerle yeniden eğit.",
  "train.retry.refuse.saveAs":
    "Tekrar denemek aynı şekilde başarısız olur. MP3 ya da WAV olarak kaydedip yeniden eğit.",
  "train.retry.refuse.filesMissing": "Yeni örneklerle yeniden eğit.",
  "train.retry.refuse.retryCap":
    "Bu ses {n} kez denendi. Yeniden eğit, tercihen farklı örneklerle.",

  "train.final.confirm": "Onayla",
  "train.final.back": "Geri",
  "train.final.next": "İleri",
};

export default train;
